import React from "react";
import { BlobShape } from "./BlobShape";
import { DotsPattern } from "./DotsPattern";

/**
 * PageDecor — décor d'arrière-plan par défaut à utiliser sur toutes les pages
 * pour appliquer le look "Mouvement & Fluidité" de manière cohérente.
 *
 * Compose deux BlobShapes flottants + un motif de points, positionnés en absolute.
 * À insérer en premier enfant d'un container avec `relative overflow-hidden`.
 *
 * Props :
 * - intensity : "subtle" (défaut) | "normal"
 */
export function PageDecor({ intensity = "subtle" }) {
  const isSubtle = intensity === "subtle";
  return (
    <>
      <BlobShape
        variant="soft"
        size="xl"
        position="top-32 -right-40"
        opacity={isSubtle ? 0.12 : 0.22}
        animation="float"
      />
      <BlobShape
        variant="tint"
        size="lg"
        position="top-[70vh] -left-32"
        opacity={isSubtle ? 0.5 : 0.75}
        animation="drift"
      />
      <DotsPattern
        position="top-[40vh] right-6"
        size={160}
        opacity={isSubtle ? 0.1 : 0.16}
      />
    </>
  );
}
